module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "sessionUrlParams": "array"
    },
    "namespace": "marketplace-unified",
    "version": "1"
  },
  "interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "sessionUrlParams": "array"
    },
    "namespace": "marketplace-unified",
    "version": "1"
  }
};